import SettingsSidebar from '@/components/dashboard/settings-page/SettingsSidebar'
import TopNavSettings from '@/components/dashboard/settings-page/TopNavSettings'
import { LoadingSidebarLayout } from '@/components/loading-ui/LoadingSidebar'
import { getIdTokenUsingQueryClient } from '@/data/queries'
import { userMeOptions } from '@/data/queryOptions'
import { useIsMobile } from '@/hooks/use-mobile'
import { useSelectedTenantStore } from '@/stores/useSelectedTenantStore'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_settings/user/$userId')({
  component: RouteComponent,
  loader: async ({ context }) => {
    const { queryClient, authState } = context

    const TENANT_ID = useSelectedTenantStore.getState().selectedTenantId
    if (!TENANT_ID) {
      throw redirect({ to: '/select-tenant' })
    }
    const idToken = await getIdTokenUsingQueryClient({
      queryClient,
      authState: authState!,
    })
    return queryClient.ensureQueryData(userMeOptions(TENANT_ID, idToken!))
  },
  pendingComponent: LoadingSidebarLayout,
})

function RouteComponent() {
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <div className="flex h-screen w-full flex-col overflow-hidden">
        <TopNavSettings />
        <main className="mt-15 w-full flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    )
  }

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <TopNavSettings />
      <main className="main-container flex-1">
        <SettingsSidebar />
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
